$(document).ready(function() {
    if($(window).width() > 767) {
        $(".top-navigation-tools .top-nav-button").prependTo("#header .navigation-buttons");
        if(shopDataLayer.header.bell.active) {
            $("<a href='"+shopDataLayer.header.bell.link+"' class='notificater'></a>").prependTo("#header .navigation-buttons");
        }
        $(".top-navigation-bar .top-navigation-tools .dropdown").prependTo(".navigation-buttons");
        $(".top-navigation-contacts .project-phone").prependTo("#header .navigation-buttons");
        $("<span class='phone-hours'>"+shopDataLayer.header.phone.hours+"</span>").appendTo("#header .navigation-buttons .project-phone");
    }
    else {
        if(shopDataLayer.header.bell.active) {
            $("<a href='"+shopDataLayer.header.bell.link+"' class='notificater'></a>").prependTo("#header .navigation-buttons");
        }
        $("<div class='navigation-header'><img src='" + $('.site-name img').attr('src') +"'><div class='navi-close'></div></div>").prependTo("#navigation");
        $("#navigation .navi-close").click(function() {
            $("body").removeClass("navigation-window-visible user-action-visible submenu-visible");
            $("#navigation .exp > a > .submenu-arrow").click();
        });
        $(".top-navigation-contacts .project-phone").appendTo("#navigation .navigation-in");
        $("<span class='phone-hours'>"+shopDataLayer.header.phone.hours+"</span>").appendTo("#navigation .navigation-in .project-phone");
    }

    // Přihlášený zákazník bez jména: Shoptet v mobilním menu vypíše „Můj účet ()“
    $("#navigation .navigationActions a[href$='/klient/'] > span > span").filter(function () {
        return $(this).text().trim() === "()";
    }).remove();

    // Auto-switch měny na EUR pro návštěvníky mimo CZ
    (function () {
        if (localStorage.getItem("currencyManualChoice")) return;
        if (localStorage.getItem("currencyAutoSwitched")) return;

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
        const lang = (navigator.language || "").toLowerCase();
        const isCzech = timezone === "Europe/Prague" && (lang.startsWith("cs") || lang === "");

        if (isCzech) return;

        const $currencyLinks = $(".dropdown-menu a");
        const $eurLink = $currencyLinks.filter(function () {
            return $(this).text().trim().toUpperCase() === "EUR";
        });

        if ($eurLink.length && $("#topNavigationDropdown").text().trim().toUpperCase() !== "EUR") {
            localStorage.setItem("currencyAutoSwitched", "EUR");
            window.location.href = $eurLink.attr("href");
        }
    })();

    // Při manuálním přepnutí měny uložit volbu
    $(document).on("click", ".dropdown-menu a", function () {
        const currency = $(this).text().trim().toUpperCase();
        if (currency === "CZK" || currency === "EUR") {
            localStorage.setItem("currencyManualChoice", currency);
        }
    });
});